export default __webpack_public_path__ + "static/media/sewa_studio.b1f5a5a1.svg";